import {
  DataTable,
  DataTableColumn,
  DataTableOptions,
  DataType,
  useNotify
} from '@globaleris/ui.library'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@material-ui/core'
import { Pageview } from '@material-ui/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { SettlementGroup } from '../../../../api/Argentia/endpoints/settlementGroups/model/settlementGroups'
import { EnumTypeSettlementGroup } from '../../../../api/Argentia/enums/typeSettlementGroup'
import { ContractModel } from '../../../../api/Argentia/model/contracts'
import { DataTableErrorHandler } from '../../../../components/errors/scopes/dataTable/dataTableError'
import { enumToSelectOptionArray } from '../../../../helpers'
import { useHttpError } from '../../../../hooks'
import { NonAuthRoutes } from '../../../../model'
import { getCustomerDomain } from '../../../../redux'

export type ViewGroupsDialogProps = {
  groups: SettlementGroup[]
  contract: ContractModel
  show: boolean
  onCloseDialog: () => void
}

export const ViewGroupsDialog: React.FC<ViewGroupsDialogProps> = ({
  groups,
  contract,
  show,
  onCloseDialog
}) => {
  const history = useHistory()
  const [t] = useTranslation(['globalerisLibrary', 'viewGroupsDialog', 'enums'])
  const { errorProps } = useHttpError()

  const dataTableColumns: DataTableColumn[] = [
    {
      name: 'description',
      label: t('viewGroupsDialog:datatable.columns.description'),
      type: DataType.TEXT
    },
    {
      name: 'typeSettlementGroup',
      label: t('viewGroupsDialog:datatable.columns.typeSettlementGroup'),
      type: DataType.SELECT,
      selectOptions: enumToSelectOptionArray(
        EnumTypeSettlementGroup,
        'enums:EnumTypeSettlementGroup'
      )
    }
  ]

  const dataTableOptions: DataTableOptions = {
    i18n: t('globalerisLibrary:dataTable', { returnObjects: true }),
    elevation: 0,
    canEdit: false,
    canDelete: false,
    canInsert: false,
    selectableRows: false,
    customInsertEditModal: true,
    analytics: {
      customer: getCustomerDomain(),
      view: t('viewGroupsDialog:datatable.analytics')
    },
    rowCustomActions: [
      {
        icon: <Pageview fontSize="small" />,
        tooltip: t('viewGroupsDialog:datatable.tooltips.view'),
        onClick: async (row: SettlementGroup) => {
          history.push(NonAuthRoutes.SettlementGroupFlexibilities, {
            settlementGroupId: row.id,
            settlementGroupCode: row.code
          })
        }
      }
    ]
  }

  return (
    <>
      <Dialog maxWidth={'md'} disableBackdropClick disableEscapeKeyDown open={show}>
        <DialogTitle disableTypography>
          <Typography variant="subtitle1">
            {t('viewGroupsDialog:title', { contractCode: contract.contractCode })}
          </Typography>
          <Typography variant="subtitle2">{t('viewGroupsDialog:subtitle')}</Typography>
        </DialogTitle>
        <DialogContent>
          <DataTable
            data={groups}
            columns={dataTableColumns}
            options={dataTableOptions}
            info={DataTableErrorHandler(errorProps)}
          />
        </DialogContent>
        <DialogActions>
          <Button size="small" color="primary" onClick={() => onCloseDialog()}>
            {t('viewGroupsDialog:actions.close')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
